import {createSlice} from '@reduxjs/toolkit'

interface ProgramRefreshLoaderState {
  refreshingProgramId: string | null
}

const initialState: ProgramRefreshLoaderState = {
  refreshingProgramId: null,
}

const programRefreshLoaderSlice = createSlice({
  name: 'programRefreshLoader',
  initialState,
  reducers: {
    showProgramRefreshLoader(state, action) {
      state.refreshingProgramId = action.payload
    },
    hideProgramRefreshLoader(state) {
      state.refreshingProgramId = null
    },
  },
})

export const {showProgramRefreshLoader, hideProgramRefreshLoader} = programRefreshLoaderSlice.actions
export default programRefreshLoaderSlice.reducer
